export enum EntriesSections {
  transactions = 'transactions',
  expenses = 'expenses',
}
export enum EntryEntity {
  MATTER = 'matter',
  INVOICE = 'invoice',
}
export enum EntriesTransactionFilters {
  MY = 'my_own',
  OTHER = 'other_authors',
  ALL_TRANSACTIONS = 'all_transactions',
  OPEN_TRANSACTIONS = 'open_transactions',
}
